import PieVisualization from './PieVisualization';
import './PieVisualization.scss';

export { schema, uiSchema } from '../schemas/PieVisualizationSchema';
export default PieVisualization;
